//////////////////
//****State****///
//////////////////

const searchState = {
    selectedProduct: "",
    searchQuery: "",
    mixerObject: {},
    data: {
        results: [],
        contentTypes: [],
        years: [],
        categories: [],
        products: [],
    },
};

const confState = {
    conferenceSlug: "",
    conferenceId: "",
    mixerObject: {},
    data: {
        results: [],
        yearData: [],
        contentTypes: [],
        years: [],
        products: [],
    },
};

const mslState = {
    selectedProducts: [],
    selectedState: "",
    selectedStateId: "",
    data: {
        results: [],
        products: [],
        states: [],
    },
};
//////////////////////////
//****Data fetching****///
//////////////////////////

async function fetchProducts() {
    try {
        const response = await fetch(
            "/wp-json/wp/v2/product?_fields=id,name,slug&per_page=100"
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching products:", error);
        return [];
    }
}

async function fetchContentTypes() {
    try {
        const response = await fetch(
            "/wp-json/wp/v2/asset-type?_fields=id,name,slug&per_page=100"
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching types:", error);
        return [];
    }
}

async function fetchYears() {
    try {
        const response = await fetch(
            "/wp-json/wp/v2/conference-year?_fields=id,name,slug&per_page=100"
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching years:", error);
        return [];
    }
}

async function fetchStates() {
    try {
        const response = await fetch(
            "/wp-json/wp/v2/region?_fields=id,name,slug&per_page=100"
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching region:", error);
        return [];
    }
}

async function fetchConferences() {
    try {
        const response = await fetch(
            "/wp-json/wp/v2/conference?_fields=id,name,slug&per_page=100"
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching conferences:", error);
        return [];
    }
}

async function fetchCategories() {
    try {
        const response = await fetch(
            "/wp-json/wp/v2/categories?_fields=id,name,slug&per_page=100"
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching categories:", error);
        return [];
    }
}

async function fetchAssets(productId) {
    try {
        let allData = [];
        let page = 1;
        let totalPages = 1;

        while (page <= totalPages) {
            const response = await fetch(
                `/wp-json/wp/v2/asset?product=${productId}&_fields=id,date,title,acf,filename,keywords,categories,asset-type,product,conference,conference-year&acf_format=standard&per_page=100&page=${page}`
            );
            const data = await response.json();

            // Update the total pages from the response headers
            const total = response.headers.get("X-WP-TotalPages");
            totalPages = parseInt(total, 10);

            allData = allData.concat(data);
            page++;
        }
        console.log("total pages " + allData.length);
        return allData;
    } catch (error) {
        console.error("Error fetching assets:", error);
        return [];
    }
}

// async function fetchAssets( productId ) {
//  try {
//      const response = await fetch(
//          `/wp-json/wp/v2/asset?product=${ productId }&_fields=id,date,title,acf,filename,keywords,categories,asset-type,product,conference,conference-year&acf_format=standard&per_page=100`
//      );
//      const data = await response.json();
//      return data;
//  } catch ( error ) {
//      console.error( 'Error fetching assets:', error );
//      return [];
//  }
// }

async function fetchMSLs() {
    try {
        const response = await fetch(
            `/wp-json/wp/v2/msl?_fields=id,date,title,acf,product,region&per_page=100`
        );
        const data = await response.json();
        return data;
    } catch (error) {
        console.error("Error fetching assets:", error);
        return [];
    }
}

async function fetchConfAssets(confId) {
    try {
        let allData = [];
        let page = 1;
        let totalPages = 1;

        while (page <= totalPages) {
            const response = await fetch(
                `/wp-json/wp/v2/asset?conference=${confId}&_fields=id,date,title,acf,filename,keywords,categories,asset-type,product,conference,conference-year&acf_format=standard&per_page=100&page=${page}`
            );
            const data = await response.json();

            // Update the total pages from the response headers
            const total = response.headers.get("X-WP-TotalPages");
            totalPages = parseInt(total, 10);

            allData = allData.concat(data);
            page++;
        }

        return allData;
    } catch (error) {
        console.error("Error fetching assets:", error);
        return [];
    }
}

async function fetchResults(productId, searchQuery) {
    try {
        const assets = await fetchAssets(productId);
        const cleanAssets = assets.map((asset) => ({
            id: asset.id,
            date: asset.date,
            title: asset.title.rendered,
            fileurl: asset.acf.fileurl,
            LowRelevanceKeywords: asset.acf.low_keywords,
            MediumRelevanceKeywords: asset.acf.medium_keywords,
            HighRelevanceKeywords: asset.acf.high_keywords,
            categories: asset.categories,
            assetType: asset["asset-type"],
            product: asset.product,
            conference: asset.conference,
            conferenceYear: asset["conference-year"],
        }));

        const filteredCleanAssets = filterResults(
            cleanAssets,
            searchQuery.toLowerCase().split(" ")
        );

        // Now you have the cleanAssets array that you can manipulate further
        return filteredCleanAssets;
    } catch (error) {
        console.error("Error fetching assets:", error);
        return [];
    }
}

function lookupAssetType(typeId) {
    const assetType = searchState.data.contentTypes.find(
        (type) => type.id === typeId
    );
    return assetType.name;
}

function lookupCongressAssetType(typeId) {
    const assetType = confState.data.contentTypes.find(
        (type) => type.id === typeId
    );
    return assetType.name;
}

function lookupProduct(productId) {
    const product = searchState.data.products.find(
        (productItem) => productItem.id.toString() === productId.toString()
    );
    return product.name;
}

function lookupStateIdBySlug(slug) {
    const state = mslState.data.states.find(
        (stateItem) => stateItem.slug === slug.toLowerCase()
    );
    return state.id;
}

function lookupStateNameBySlug(slug) {
    const state = mslState.data.states.find(
        (stateItem) => stateItem.slug === slug.toLowerCase()
    );
    return state.name;
}

function lookupMSLProduct(productId) {
    const product = mslState.data.products.find(
        (productItem) => productItem.id.toString() === productId.toString()
    );
    //check for register symbol and wrap in superscript
    if (product.name.includes("®")) {
        product.name = product.name.replace("®", "<sup>®</sup>");
    }
    return product.name;
}

function lookupYear(yearId) {
    const year = searchState.data.years.find(
        (yearItem) => yearItem.id === yearId
    );
    //if year is undefined, return empty string
    if (!year) {
        return "&nbsp;";
    }
    return year.name;
}

function lookupCongressYear(yearId) {
    const year = confState.data.years.find(
        (yearItem) => yearItem.id === yearId
    );
    //if year is undefined, return empty string
    if (!year) {
        return "&nbsp;";
    }
    return year.name;
}

////////////////////
//****Startup****///
///////////////////
async function init() {
    //check if search form exists or if results-container exists
    if (
        document.getElementById("search-form") ||
        document.querySelector(".results-container")
    ) {
        console.log("init search");
        const [contentTypes, years, categories, products] = await Promise.all([
            fetchContentTypes(),
            fetchYears(),
            fetchCategories(),
            fetchProducts(),
        ]);

        searchState.data.contentTypes = contentTypes;
        searchState.data.years = years;
        searchState.data.categories = categories;
        searchState.data.products = products;

        //fill the state object
        // searchState.data.contentTypes = await fetchContentTypes();
        // searchState.data.years = await fetchYears();
        // searchState.data.categories = await fetchCategories();
        // searchState.data.products = await fetchProducts();

        configSearch();
        initResults();
    }
}

function configSearch() {
    //check if form exists
    if (document.getElementById("search-form")) {
        const dropdown = document.getElementById("product");
        searchState.data.products.forEach((product) => {
            const option = document.createElement("option");
            option.value = product.id;
            option.textContent = fixRball(product.name);
            dropdown.appendChild(option);
        });

        document
            .getElementById("search-form")
            .addEventListener("submit", async function (event) {
                event.preventDefault(); // Prevent form submission
                //send users to /results with query params for product and query with url encoding for the query
                const productId = document.getElementById("product").value;
                const searchQuery =
                    document.getElementById("search-query-input").value;
                //url encode the search query
                const encodedSearchQuery = encodeURIComponent(searchQuery);
                window.location.href = `/results?product=${productId}&query=${encodedSearchQuery}`;
            });
    }
}

async function initResults() {
    //if queryparams for product and query exist, set the search state
    const urlParams = new URLSearchParams(window.location.search);
    const productId = urlParams.get("product");
    const searchQuery = urlParams.get("query");
    //if product and query exist, set the search state
    if (productId && searchQuery) {
        searchState.selectedProduct = productId;
        searchState.searchQuery = searchQuery;
        // if product is selected, fetch results
        if (searchState.selectedProduct) {
            searchState.data.results = await fetchResults(
                searchState.selectedProduct,
                searchState.searchQuery
            );
            if (searchState.data.results.length === 0) {
                document.querySelector(".results-container").innerHTML =
                    generateNoResults();
            }
            //generate results view
            else {
                generateResultsView();
            }
            //save search state to local storage
        }
    }
}

////////////////////////////
//****View Generation****///
////////////////////////////

function generateNoResults() {
    const noResultsHtml = `
    <div class="grid-x no-results-container">
        <div class="cell small-12">
            <div class="grid-x">    
                <div class="text-center cell small-12">
                    <h2>No results</h2>
                </div>  
            </div>  
        </div>  
    </div>  
    `;
    return noResultsHtml;
}

function generateResultsView() {
    const results = `

<div class="grid-x grid-padding-x">
    <div class="cell small-12 text-right">
    <a class="sort-button sort-grid" href="#"><i class="sorting-icon fa-solid fa-grip"></i></a><a class="sort-button sort-list" href="#"><i class="sorting-icon fa-solid fa-list"></i></a>
    </div>
  <div class="cell small-12 medium-4 large-3">
  ${generateFilters()}
    </div>
    <div class="cell small-12 medium-8 large-9">
    <div class="grid-x mix-container result-container container-grid-view">
        ${generateResults()} 
    </div>
  </div>
</div>`;

    // Inject the results into the DOM by class
    document.querySelector(".results-container").innerHTML = results;
    // eslint-disable-next-line no-undef
    jQuery(".match-titles").matchHeight({
        byRow: false,
        property: "height",
        target: null,
        remove: false,
    });
    //create h2 element and append to the start of result-outer-container
    const h2 = document.createElement("h2");
    h2.textContent =
        "Your results for " + lookupProduct(searchState.selectedProduct);
    //add superscripts to ® in product name
    if (h2.textContent.includes("®")) {
        h2.innerHTML = h2.innerHTML.replace("®", "<sup>®</sup>");
    }
    document.querySelector(".result-outer-container").prepend(h2);

    //when users click on sorting button, trigger the sorting function
    document
        .querySelector(".sort-grid")
        .addEventListener("click", function (event) {
            event.preventDefault(); // Prevent form submission
            showAsGrid();
        });

    document
        .querySelector(".sort-list")
        .addEventListener("click", function (event) {
            event.preventDefault(); // Prevent form submission
            showAsList();
        });
    console.log("before mix!");
    const mixer = mixitup(".mix-container", {
        multifilter: {
            enable: true,
        },
        callbacks: {},
    });
    console.log(searchState);
    searchState.mixerObject = mixer;
}

function showAsGrid() {
    jQuery(".result-item").each(function () {
        jQuery(this).addClass("small-12 medium-6 large-4");
        jQuery(this).removeClass("small-12");
        jQuery(this).find(".result-body-cell").addClass("small-12");
        jQuery(this).find(".result-button-cell").addClass("small-12");
        jQuery(this).find(".result-body-cell").removeClass("auto");
        jQuery(this).find(".result-button-cell").removeClass("shrink");
        jQuery(this).find(".result-content").addClass("grid-view");
        jQuery(this).find(".result-content").removeClass("list-view");
        jQuery(this).find(".result-title").addClass("match-titles");
        jQuery(".result-container").addClass("container-grid-view");
        jQuery(".result-container").removeClass("container-list-view");
    });

    jQuery(".match-titles").matchHeight({
        byRow: false,
        property: "height",
        target: null,
        remove: false,
    });
}

function showAsList() {
    jQuery(".result-item").each(function () {
        jQuery(this).removeClass("small-12 medium-6 large-4");
        jQuery(this).addClass("small-12");
        jQuery(this).find(".result-body-cell").removeClass("small-12");
        jQuery(this).find(".result-button-cell").removeClass("small-12");
        jQuery(this).find(".result-body-cell").addClass("auto");
        jQuery(this).find(".result-button-cell").addClass("shrink");
        jQuery(this).find(".result-content").removeClass("grid-view");
        jQuery(this).find(".result-content").addClass("list-view");
        jQuery(".result-container").removeClass("container-grid-view");
        jQuery(".result-container").addClass("container-list-view");
    });

    jQuery(".match-titles").matchHeight({
        byRow: false,
        property: "height",
        target: null,
        remove: true,
    });
}

function generateFilters() {
    //filter contentTypes to only include those that are in the results
    const filteredContentTypes = searchState.data.contentTypes.filter(
        (type) =>
            searchState.data.results.filter(
                (result) => result.assetType[0] === type.id
            ).length > 0
    );

    const contentTypeOptions = filteredContentTypes
        .map(
            (option) =>
                `<label class="filter-check-label"><input type="checkbox" value='[data-content-type="${option.id}"]' name="${option.id}" class="filter-checkbox">${option.name}</label>`
        )
        .join("");

    //filter years to only include those that are in the results
    const filteredYears = searchState.data.years.filter(
        (year) =>
            searchState.data.results.filter(
                (result) => result.conferenceYear[0] === year.id
            ).length > 0
    );

    const yearOptions = filteredYears
        .map(
            (option) =>
                `<label class="filter-check-label"><input type="checkbox" value='[data-conference-year="${option.id}"]' name="${option.id}" class="filter-checkbox">${option.name}</label>`
        )
        .join("");

    //filter categories to only include those that are in the results
    const filteredCategories = searchState.data.categories.filter(
        (category) =>
            searchState.data.results.filter((result) =>
                result.categories.includes(category.id)
            ).length > 0
    );

    const categoryOptions = filteredCategories
        .map(
            (option) =>
                `<label class="filter-check-label"><input type="checkbox" value='[data-category-${option.id}]' name="${option.id}" class="filter-checkbox">${option.name}</label>`
        )
        .join("");

    const filterHtml = `
    <form class="filter-form">
      <div class="grid-x">
        <div class="cell small-12 filter-title">
        Filter by
        </div>
        <fieldset class="cell small-12" data-filter-group="type">
          <label for="contentType">Content type</label>
          <div id="contentType"  >
            ${contentTypeOptions}
          </div>
        </fieldset>
        <fieldset class="cell small-12" data-filter-group="year">
          <label for="year">Year</label>
          <div id="year" >
            ${yearOptions}
          </div>
        </fieldset>
        <fieldset class="cell small-12" data-filter-group="category" >
          <label for="category">Category</label>
          <div id="category" >
            ${categoryOptions}
          </div>
        </fieldset>
      </div>
      <div class="grid-x">

      </div>                
    </form>
  `;
    return filterHtml;
}

function generateCategoryDataAttr(categories) {
    //map the categories array to an array of data attributes with the format data-category-id
    return categories.map((category) => `data-category-${category}`).join(" ");
}

function generateResults(isList) {
    // loop through searchState.data.results and build an html object for each result that contains the title and a link to the filename

    const resultsHtml = searchState.data.results
        .map(
            (result) =>
                `<div class="cell small-12 medium-6 large-4 result-item mix" ${generateCategoryDataAttr(
                    result.categories
                )} data-conference-year="${
                    result.conferenceYear[0]
                }" data-content-type="${result.assetType[0]}">
            <div class="grid-x">
                <div class="cell small-12 result-body-cell">
                    <div class="grid-x result-content grid-view">
                        <div class="result-title match-titles cell small-12">
                            ${fixRball(result.title)}
                        </div>
                        <div class="result-type cell small-12">
                        ${lookupYear(result.conferenceYear[0])}
                        </div>
                        <div class="result-type cell small-12">
                        ${lookupAssetType(result.assetType[0])}
                        </div>
                    </div>
                </div>
                <div class="cell result-button-cell small-12">  
                    <div class="grid-x">    
                        <div class="text-center download-container cell small-12">  
                            <a class="result-button" href="${
                                result.fileurl
                            }" target="_blank">Download</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        `
        )
        .join("");

    return resultsHtml;
}

function generateCongressResults() {
    //fetch confs
    fetchConferences().then((conferences) => {
        //filter to the current conference

        const currentConf = conferences.filter(
            (conference) => conference.slug === confState.conferenceSlug
        );
        //get the id of the current conference and set the state

        confState.conferenceId = currentConf[0].id;

        fetchConfAssets(confState.conferenceId).then((assets) => {
            //clean up the datacand push it into the state
            confState.data.results = assets.map((asset) => ({
                id: asset.id,
                date: asset.date,
                title: asset.title.rendered,
                fileurl: asset.acf.fileurl,
                keywords: asset.acf.keywords,
                categories: asset.categories,
                assetType: asset["asset-type"],
                product: asset.product,
                conference: asset.conference,
                conferenceYear: asset["conference-year"],
            }));

            buildCongressResultsView();
        });
    });
}

async function initCongressMatResults() {
    // Define the pattern for matching /congress-materials/***
    const path = window.location.pathname;
    const pattern = /^\/congress-materials\/(.+)$/;
    let currentConferenceSlug = "";
    // Use RegExp.exec() to find the match
    const match = pattern.exec(path);

    if (match) {
        currentConferenceSlug = match[1]; // Extract the captured string
        //remove trailing slash
        currentConferenceSlug = currentConferenceSlug.replace(/\/$/, "");
        confState.conferenceSlug = currentConferenceSlug;

        const [contentTypes, years, products] = await Promise.all([
            fetchContentTypes(),
            fetchYears(),
            fetchCategories(),
            fetchProducts(),
        ]);

        confState.data.contentTypes = contentTypes;
        confState.data.years = years;
        confState.data.products = products;
        console.log(confState);

        generateCongressResults();
    }
}
function buildCongressResultsView() {
    const results = `
    <div class="grid-x grid-margin-x">
    <div class="cell small-12 text-right">
    <a class="sort-button sort-congress-grid" href="#"><i class="sorting-icon fa-solid fa-grip"></i></a><a class="sort-button sort-congress-list" href="#"><i class="sorting-icon fa-solid fa-list"></i></a>
    </div>
    <div class="cell small-12 medium-3">
    ${generateCongressFilters()}
    </div>
    <div class="cell small-12 medium-9">
    <div class="grid-x mix-container  result-container container-grid-view">
            ${generateCongressResultItems()}
        </div>
        </div>
        </div>
    </div>`;
    // Inject the results into the DOM by class
    document.querySelector(".congress-results-container").innerHTML = results;
    document
        .querySelector(".sort-congress-grid")
        .addEventListener("click", function (event) {
            event.preventDefault(); // Prevent form submission
            showCongressAsGrid();
        });

    document
        .querySelector(".sort-congress-list")
        .addEventListener("click", function (event) {
            event.preventDefault(); // Prevent form submission
            showCongressAsList();
        });

    const mixer = mixitup(".mix-container", {
        multifilter: {
            enable: true,
        },
        callbacks: {},
    });
    jQuery(".result-title").matchHeight({
        byRow: false,
        property: "height",
        target: null,
        remove: false,
    });
}

function showCongressAsGrid() {
    jQuery(".result-item").each(function () {
        jQuery(this).addClass("small-12 medium-6 large-4");
        jQuery(this).removeClass("small-12");
        jQuery(this).find(".result-body-cell").addClass("small-12");
        jQuery(this).find(".result-button-cell").addClass("small-12");
        jQuery(this).find(".result-body-cell").removeClass("auto");
        jQuery(this).find(".result-button-cell").removeClass("shrink");
        jQuery(this).find(".result-content").addClass("grid-view");
        jQuery(this).find(".result-content").removeClass("list-view");
        jQuery(this).find(".result-title").addClass("match-titles");
        jQuery(".result-container").addClass("container-grid-view");
        jQuery(".result-container").removeClass("container-list-view");
    });

    jQuery(".match-titles").matchHeight({
        byRow: false,
        property: "height",
        target: null,
        remove: false,
    });
}

function showCongressAsList() {
    jQuery(".result-item").each(function () {
        jQuery(this).removeClass("small-12 medium-6 large-4");
        jQuery(this).addClass("small-12");
        jQuery(this).find(".result-body-cell").removeClass("small-12");
        jQuery(this).find(".result-button-cell").removeClass("small-12");
        jQuery(this).find(".result-body-cell").addClass("auto");
        jQuery(this).find(".result-button-cell").addClass("shrink");
        jQuery(this).find(".result-content").removeClass("grid-view");
        jQuery(this).find(".result-content").addClass("list-view");
        jQuery(".result-container").removeClass("container-grid-view");
        jQuery(".result-container").addClass("container-list-view");
    });

    jQuery(".match-titles").matchHeight({
        byRow: false,
        property: "height",
        target: null,
        remove: true,
    });
}

function generateCongressFilters() {
    //filter years to only include those that are in the results
    const filteredYears = confState.data.years.filter(
        (year) =>
            confState.data.results.filter(
                (result) => result.conferenceYear[0] === year.id
            ).length > 0
    );
    console.log(filteredYears);
    const yearOptions = filteredYears
        .map(
            (option) =>
                `<label class="filter-check-label"><input type="checkbox" value='[data-conference-year="${option.id}"]' name="${option.id}" class="filter-checkbox">${option.name}</label>`
        )
        .join("");

    //filter contentTypes to only include those that are in the results
    const filteredContentTypes = confState.data.contentTypes.filter(
        (type) =>
            confState.data.results.filter(
                (result) => result.assetType[0] === type.id
            ).length > 0
    );
    const contentTypeOptions = filteredContentTypes
        .map(
            (option) =>
                `<label class="filter-check-label"><input type="checkbox" value='[data-content-type="${option.id}"]' name="${option.id}" class="filter-checkbox">${option.name}</label>`
        )
        .join("");

    const filterHtml = `
    <form class="filter-form">
      <div class="grid-x">
        <div class="cell small-12 filter-title">
        Filter by
        </div>
        <div class="cell small-12" data-filter-group="type">
            <label for="year">Content type</label>
            <div id="year">
            ${contentTypeOptions}
            </div>
        </div>
        <div class="cell small-12" data-filter-group="year">
          <label for="year">Year</label>
          <div id="year">
            ${yearOptions}
          </div>
        </div>
      </div>
      <div class="grid-x">

      </div>                
    </form>
  `;
    return filterHtml;
}

function generateCongressResultItems(isList) {
    const resultsHtml = confState.data.results
        .map(
            (result) =>
                `<div class="cell small-12 medium-6 large-4 result-item mix" ${generateCategoryDataAttr(
                    result.categories
                )} data-conference-year="${
                    result.conferenceYear[0]
                }" data-content-type="${result.assetType[0]}">
            <div class="grid-x">
                <div class="cell small-12 result-body-cell">
                    <div class="grid-x result-content grid-view">
                        <div class="result-title match-titles cell small-12">
                            ${fixRball(result.title)}
                        </div>
                        <div class="result-type cell small-12">
                        ${lookupCongressAssetType(result.assetType[0])}
                        </div>
                        <div class="result-type cell small-12">
                        ${lookupCongressYear(result.conferenceYear[0])}
                        </div>
                    </div>
                </div>
                <div class="cell result-button-cell small-12">  
                    <div class="grid-x">    
                        <div class="text-center download-container cell small-12">  
                            <a class="result-button" href="${
                                result.fileurl
                            }" target="_blank">Download</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>`
        )
        .join("");
    return resultsHtml;
}

//msl connect

function initMslConnect() {
    configMSLSearch();
    initMslResults();
}

function configMSLSearch() {
    //check if search form exists
    if (document.getElementById("msl-form")) {
        fetchProducts().then((products) => {
            //generaate products options html

            const productOptions = products.map(
                (product) =>
                    `<option value="${product.id}">${product.name}</option>`
            );
            //inject the html into the select
            document.getElementById("msl-product").innerHTML = productOptions;

            jQuery("#msl-product").zmultiselect({
                filter: false,
                filterResult: false,
                selectAll: false,
                get: "zmultiselect",
                placeholder: "Selet one or more",
                live: "#menu_live",
            });

            document
                .getElementById("msl-form")
                .addEventListener("submit", async function (event) {
                    event.preventDefault(); // Prevent form submission
                    //send users to /results with query params for product and query with url encoding for the query
                    //get products selected
                    const selectedProducts =
                        jQuery(".zms").zmultiselect("getValue");
                    //get state selected
                    const selectedState =
                        document.getElementById("state").value;
                    //url encode the search query
                    //const encodedSearchQuery = encodeURIComponent( searchQuery );
                    window.location.href = `/msl/connect/msl-results?products=${selectedProducts.join(
                        ","
                    )}&state=${selectedState}`;
                });
        });
    }
}

async function initMslResults() {
    //fetch products and states
    //if queryparams for product and search are present
    const urlParams = new URLSearchParams(window.location.search);
    const productsParams = urlParams.get("products");
    const state = urlParams.get("state");
    //if product and query exist, set the search state

    if (productsParams && state) {
        const [years, products, states] = await Promise.all([
            fetchYears(),
            fetchProducts(),
            fetchStates(),
        ]);
        //set selectedProduct from unencoded params

        mslState.selectedProducts = productsParams.split(",");
        mslState.selectedState = state;
        mslState.data.states = states;
        mslState.data.years = years;
        mslState.data.products = products;

        mslState.selectedStateId = lookupStateIdBySlug(state);

        //add state name to msl-result-title element
        document.querySelector(".msl-result-title").textContent =
            document.querySelector(".msl-result-title").textContent +
            " in " +
            lookupStateNameBySlug(state);
        generateMslResultsView();
    }
}

function generateMslResultsView() {
    fetchMSLs().then((msls) => {
        //match and filter any msls with a region in the region array that matches the selected states id
        const mslByState = msls.filter((msl) =>
            msl.region.some((region) => region === mslState.selectedStateId)
        );

        //filter the msls by the selected products
        mslState.data.results = mslByState.filter((msl) => {
            const isMatchingProduct = msl.product.some((product) =>
                mslState.selectedProducts.includes(product.toString())
            );

            if (isMatchingProduct) {
                console.log("Matching MSL:", msl); // Logging the matching MSL object
            } else {
                console.log("Not Matching MSL:", msl); // Logging the matching MSL object
                console.log(mslState.selectedProducts);
                console.log(msl.product[0]);
            }

            return isMatchingProduct;
        });

        const results = `
    <div class="grid-x">
    <div class="cell small-12">
    <div class="grid-x mix-container">
            ${generateMslResultItems()}
        </div>
        </div>
        </div>
    </div>`;
        // Inject the results into the DOM by class
        document.querySelector(".msl-results-container").innerHTML = results;
    });

    //const mixer = mixitup( '.mix-container' );
}

function generateMslResultItems() {
    // Fetch MSL and product data
    const msls = mslState.data.results;

    // Filter MSL results by region and product(s)
    const filteredResults = msls.filter((result) => {
        // Filter MSL results by region
        const isMatchingRegion = result.region.some(
            (region) => region === mslState.selectedStateId
        );

        // Filter MSL results by product
        const isMatchingProduct = result.product.some((product) =>
            mslState.selectedProducts.includes(product.toString())
        );

        return isMatchingRegion && isMatchingProduct;
    });

    // Generate HTML for MSL results, for each product associated with MSL
    let resultsHtml = "";

    // For each filtered result
    filteredResults.forEach((result) => {
        // For each selected product, generate a result item
        mslState.selectedProducts.forEach((productId) => {
            // If the MSL result includes the selected product
            if (result.product.includes(parseInt(productId))) {
                // Get the MSL for the product
                const msl = getMSLForProduct(productId);

                // Generate the result item HTML
                resultsHtml += `
                <div class="cell msl-item small-12 medium-6" data-product="${productId}">
                    <div class="grid-x">
                        <div class="cell small-12">
                            <div class="msl-product-title">
                                ${lookupMSLProduct(productId)}
                            </div>
                        </div>
                    </div>
                    <div class="grid-x msl-content">
                        <div class="cell small-12 msl-name">
                            ${result.title.rendered}
                        </div>
                        <div class="cell small-12 msl-email">
                            ${result.acf.email}
                        </div>
                    </div>
                </div>
                `;
            }
        });
    });

    return resultsHtml;
}

function getMSLForProduct(productid) {
    const newMsl = {
        name: "",
        email: "",
    };
    const msls = mslState.data.results;
    msls.forEach((msl) => {
        //if msl.product array includes productid, set the name and email
        if (msl.product.includes(parseInt(productid))) {
            newMsl.name = msl.title.rendered;
            newMsl.email = msl.acf.email;
        }
    });

    return newMsl;
}

function filterResults(results, queryTermsArray) {
    const threshold = 8;
    const highPriority = threshold;
    const titlePriority = threshold;
    const mediumPriority = 4;
    const lowPriority = 2;

    // Iterate through each result
    const filteredResults = [];
    console.log("query terms: " + queryTermsArray);
    const pointsArray = [];
    results.forEach((item) => {
        // Convert keyword strings to lowercase arrays
        const hKey = item.HighRelevanceKeywords.toLowerCase().split(/[ ,]+/);
        const mKey = item.MediumRelevanceKeywords.toLowerCase().split(/[ ,]+/);
        const lKey = item.LowRelevanceKeywords.toLowerCase().split(/[ ,]+/);
        //clean and split title
        const titleArrWithoutPunctuation = item.title
            .toLowerCase()
            .replace(/[.,\/#!$%\^&\*;:{}=\_`~()]/g, "")
            .toLowerCase()
            .split(/[ ,]+/);
        const titlesWithoutCommonWords = [];
        titleArrWithoutPunctuation.forEach((titlePiece) => {
            if (!isCommonWord(titlePiece)) {
                titlesWithoutCommonWords.push(titlePiece);
            }
        });

        // Initialize counters for relevance levels
        let titleRelevance = 0;
        let high = 0;
        let medium = 0;
        let low = 0;

        //check for title relevant keywords
        let titleCount = 0;
        titlesWithoutCommonWords.forEach((title) => {
            queryTermsArray.forEach((term) => {
                if (title === term) {
                    titleCount++;
                }
                titleRelevance = titleCount * titlePriority; // Calculate high priority
            });
        });

        // Check for high relevance keywords
        let hCount = 0;
        hKey.forEach((keyword) => {
            queryTermsArray.forEach((term) => {
                if (keyword === term) {
                    hCount++;
                }
                high = hCount * highPriority; // Calculate high priority
            });
        });

        // Check for medium relevance keywords
        let mCount = 0;
        mKey.forEach((keyword) => {
            queryTermsArray.forEach((term) => {
                if (keyword === term) {
                    mCount++;
                }
                medium = mCount * mediumPriority; // Calculate medium priority
            });
        });

        // Check for low relevance keywords
        let lCount = 0;
        lKey.forEach((keyword) => {
            queryTermsArray.forEach((term) => {
                if (keyword === term) {
                    lCount++;
                }
                low = lCount * lowPriority; // Calculate low priority
            });
        });

        // Calculate total points based on relevance levels
        const points = titleRelevance + high + medium + low;
        //log the point count plus the first 13 characters of the title
        if (points > 0) {
            pointsArray.push(points);
            item.points = points;
            filteredResults.push(item);
        }
    });

    // Sort results by points
    const sorted = filteredResults.sort((a, b) => b.points - a.points);

    //find the median score
    const median = pointsArray.sort()[Math.floor(pointsArray.length / 2)];
    //find the mean score
    const sum = pointsArray.reduce((a, b) => a + b, 0);
    const mean = sum / pointsArray.length;
    const roundedMean = Math.floor(mean);
    console.log("mean: " + roundedMean);
    console.log("median: " + median);
    //filter out results with less than the median score
    const lessThanMean = sorted.filter((result) => {
        // if the result has more than the mean - 1 point, accept it
        // could set a max here?
        if (result.points >= roundedMean - 1) {
            console.log(
                "accepted: " +
                    result.points +
                    " " +
                    result.title.trim().substring(0, 34)
            );
            return result;
        }

        console.log(
            "rejected: " +
                result.points +
                " " +
                result.title.trim().substring(0, 34)
        );
    });
    return lessThanMean;
}

function isCommonWord(word) {
    const commonWordsArray = [
        "the",
        "be",
        "to",
        "of",
        "and",
        "a",
        "in",
        "that",
        "have",
        "I",
        "it",
        "for",
        "not",
        "on",
        "with",
        "he",
        "as",
        "you",
        "do",
        "at",
        "this",
        "but",
        "his",
        "by",
        "from",
        "they",
        "we",
        "say",
        "her",
        "she",
        "or",
        "an",
        "will",
        "my",
        "one",
        "all",
        "would",
        "there",
        "their",
        "what",
        "so",
        "up",
        "out",
        "if",
        "about",
        "who",
        "get",
        "which",
        "go",
        "me",
        "when",
        "make",
        "can",
        "like",
        "time",
        "no",
        "just",
        "him",
        "know",
        "take",
        "people",
        "into",
        "year",
        "your",
        "good",
        "some",
        "could",
        "them",
        "see",
        "other",
        "than",
        "then",
        "now",
        "look",
        "only",
        "come",
        "its",
        "over",
        "think",
        "also",
        "back",
        "after",
        "use",
        "two",
        "how",
        "our",
        "work",
        "first",
        "well",
        "way",
        "even",
        "new",
        "want",
        "because",
        "any",
        "these",
        "give",
        "day",
        "most",
        "us",
        "et",
        "al",
        "et.",
        "al.",
        "et.al",
    ];
    if (commonWordsArray.includes(word)) {
        return true;
    }

    return false;
}

//find register marks and superscript them
function fixRball(html) {
    const fixedHtml = html.replace(/®/g, "®");
    return fixedHtml;
}

window.addEventListener("DOMContentLoaded", initCongressMatResults);

// Call the populateDropdown function when the page loads
window.addEventListener("DOMContentLoaded", init);
window.addEventListener("DOMContentLoaded", initMslConnect);
